/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneCheckout as ResolvedStandaloneCheckout } from 'base/components/standalone/Checkout';

export const Checkout: typeof ResolvedStandaloneCheckout = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneCheckout {...props} />
        </ErrorBoundary>
    );
});

export type CheckoutProps = PropsFromComponent<typeof Checkout>;

/** @deprecated Use slot architecture instead */
export const CheckoutWith = (extras: DynamicStandaloneExtras): typeof Checkout => {
    return function Checkout(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Checkout');
        return <ResolvedStandaloneCheckout {...mergeProps({ options: { theme } }, props)} />;
    }
}